import './ProfilePage.css';

function fmtDayMonth(ms) {
  return new Date(ms).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

function CheckIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  );
}

function ExternalIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
      <polyline points="15 3 21 3 21 9"/>
      <line x1="10" y1="14" x2="21" y2="3"/>
    </svg>
  );
}

// Pure presentational — state/fetch logic lives in useOrganizerPayouts, shared
// by ProfilePage and BusinessDashboard so both render the exact same UI.
export function OrganizerPayouts({ connectStatus, connectLoading, connectError, onConnectStripe }) {
  return (
    <section className="pp__section">
      <h3 className="pp__section-title">Organizer Payouts</h3>
      <p className="pp__section-desc">
        Connect a Stripe account to receive ticket revenue directly. You keep 100% of your ticket price.
      </p>

      {connectStatus === null ? (
        <div className="pp__connect-loading">
          <span className="pp__spinner" /> Checking…
        </div>
      ) : connectStatus.connected ? (
        <div className="pp__connect-status">
          {connectStatus.chargesEnabled ? (
            <>
              <div className="pp__connect-connected">
                <CheckIcon />
                Stripe account connected &amp; active
              </div>
              {connectStatus.payout && (
                <div className="pp__payout">
                  <span className="pp__payout-sub">
                    {connectStatus.payout.nextPayoutArrival
                      ? `Next payout arrives ${fmtDayMonth(connectStatus.payout.nextPayoutArrival)}`
                      : connectStatus.payout.delayDays != null
                        ? `Ticket revenue is held ~${connectStatus.payout.delayDays} days after each sale, then paid to your bank.`
                        : 'Ticket revenue is paid to your bank on a rolling schedule.'}
                    {' '}See your balance in the Stripe dashboard.
                  </span>
                </div>
              )}
              {connectStatus.dashboardUrl && (
                <a
                  href={connectStatus.dashboardUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pp__btn pp__btn--outline pp__btn--block"
                >
                  Open Stripe Dashboard <ExternalIcon />
                </a>
              )}
            </>
          ) : (
            <>
              <div className="pp__connect-pending">
                Account connected — onboarding incomplete
              </div>
              <button
                className="pp__btn pp__btn--primary"
                onClick={onConnectStripe}
                disabled={connectLoading}
              >
                {connectLoading ? 'Opening…' : 'Complete onboarding'}
              </button>
            </>
          )}
        </div>
      ) : (
        <div className="pp__connect-status">
          <button
            className="pp__btn pp__btn--stripe"
            onClick={onConnectStripe}
            disabled={connectLoading}
          >
            {connectLoading ? (
              <><span className="pp__spinner pp__spinner--white" /> Opening…</>
            ) : (
              <>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="2" y="6" width="20" height="12" rx="2"/><path d="M2 10h20"/></svg>
                Connect with Stripe
              </>
            )}
          </button>
          <p className="pp__connect-note">You'll be redirected to Stripe to set up payouts.</p>
        </div>
      )}

      {connectError && <div className="pp__connect-error">{connectError}</div>}
    </section>
  );
}
